
      
    if(module.hot) {
      const bucket = require("/app/build/i18n/browser-bucket.js");
      bucket.add('src/components/freebusy/assets/freebusy.lang.json', {"freebusy.all_day.event":{"ru_RU":"Весь день","en_US":"All day"}}) 
    }
   
      
      export default "src/components/freebusy/assets/freebusy.lang.json"
    